module.exports = __webpack_public_path__ + "static/media/kiss-bi-conometry.63fdc207.png";